import React from 'react';
import styles from './Button.module.css';

const Button = ({ text, onClick, wrapperClassName, isLoading, wrapperStyles }) => {
    return (
        <div
            className={`${styles.button} ${wrapperClassName} ${isLoading ? styles.hover_break : ''}`}
            style={wrapperStyles || {}}
            onClick={onClick}>
            {isLoading ? <div className={styles.loading_spinner}></div> : text}
        </div>
    );
};

export default Button;